import { Form } from "antd";
import { HeaderOverview, IRenderBarChart, RenderBarChart } from "components";
import dayjs from "config/dayjs";
import { APPLICATION_MENUS } from "menus/application";
import { MAIN_MENUS } from "menus/main";
import { PROPERTY_MENUS } from "menus/property";
import { Wrapper } from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { IData } from "service/dashboard/interface";
import { useGetPropertyDashboardGraph } from "service/dashboard/property/overview";
import { ErrorDashboard, LoadingDashboard, NoDataDashboard } from "../..";

const colors = [
  "#7986CB",
  "#3F51B5",
  "#4285F4",
  "#33B679",
  "#0B8043",
  "#C0CA33",
  "#F6BF26",
  "#F09300",
  "#EF6C00",
  "#D50000",
  "#D81B60",
  "#E67C73",
  "#7986CB",
  "#3F51B5",
];

const ListMenus = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const listMenusPropertyDate = Form.useWatch("listMenusPropertyDate");
  const date = findDate(listMenusPropertyDate, "month");

  const { data, isFetching, isError, error } = useGetPropertyDashboardGraph({
    ...date,
  });
  const { formatDate } = useAppLanguage();

  const calculatedYesterday = dayjs().subtract(1, "day");

  const getData: IData[] =
    data?.map((e) => {
      const menus = [...MAIN_MENUS, ...PROPERTY_MENUS, ...APPLICATION_MENUS];
      const menu = menus.find((menu) => menu.code === e.menuCode);
      const title = menu ? t(menu.title, { ns: "menu" }) : "";
      return { count: e.totalClickerByMenu, title };
    }) || [];

  const findNoCount = getData.some((e) => e.count > 0);

  const dataBar: IRenderBarChart = {
    data: getData,
    dataKeyX: "title",
    dataKeyY: "count",
    color: "#F6BF26",
    colorsBar: colors,
    isMenu: true,
  };

  return (
    <Wrapper className="h-[400px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("menu-item")}
          name="listMenusPropertyDate"
          subTitle={`${t("last_updated_on")} ${formatDate({
            date: calculatedYesterday,
            format: "normal",
          })}`}
        />

        {isError ? (
          <ErrorDashboard error={error} height="300px" />
        ) : !data || data.length <= 0 || !findNoCount ? (
          <NoDataDashboard height="300px" />
        ) : (
          <RenderBarChart {...dataBar} />
        )}
      </LoadingDashboard>
    </Wrapper>
  );
};

export default ListMenus;
